import { useAtom } from "jotai";
import { serviceSync } from "../../../services/sync.service";
import Icon from "../../commons/Icon";
import { s } from "../../../lib/styler";
import { useEffect, useRef } from "react";

export type MessagingSearchProps = {
}

export default function MessagingSearch({ }: MessagingSearchProps) {
    const [searchFilter, setSearchFilter] = useAtom(serviceSync.atomSearchFilter);
    const [searchShortcutCounter] = useAtom(serviceSync.atomSearchShortcutCounter);
    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (searchShortcutCounter > 0) {
            inputRef.current?.focus();
        }
    }, [searchShortcutCounter]);

    return (
        <div className="flex justify-center items-center h-full px-6 ">
            <div className="relative w-full">
                <input
                    ref={inputRef}
                    className="border border-gray-300 w-full text-sm px-3 py-[5px] rounded-md"
                    type="text"
                    placeholder="Search Messages"
                    value={searchFilter}
                    onChange={(e) => setSearchFilter(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === "Escape") {
                            setSearchFilter("");
                            inputRef.current?.blur();
                        }
                    }}
                />
                <div className={s("absolute top-0 bottom-0 right-0 flex items-center px-[7px] cursor-pointer ", {}, [
                    ["opacity-100", "opacity-0 pointer-events-none", searchFilter.trim() !== ""]
                ])} onClick={() => setSearchFilter("")}>
                    <Icon name="bx-x" color="#999" size="22px" />
                </div>
            </div>
        </div>
    );
}
